import React from 'react';
import './StickyFooterCTA.css';

interface StickyFooterCTAProps {
  theme: 'premium' | 'energetic';
  onClick: () => void;
}

const StickyFooterCTA: React.FC<StickyFooterCTAProps> = ({ theme, onClick }) => {
  return (
    <div className="v1-sticky-footer-cta">
      <div className="v1-sticky-content">
        <span className="v1-sticky-text">Gotowy na sukces?</span>
        <button className="v1-btn-primary v1-btn-sticky" onClick={onClick}>
          🎯 Umów lekcje
        </button>
      </div>
    </div>
  );
};

export default StickyFooterCTA;
